import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {IUser} from '../../core/interfaces/user';
import {jwtDecode} from 'jwt-decode';
import {SENSOR_MONTH_SUBSCRIPTIONS, SENSOR_YEAR_SUBSCRIPTIONS} from '../../core/consts/subscriptions-ids';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionsService {
  devicesList: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  subscriptionsError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(undefined);
  userDevice = null;

  private consumerKey = 'ck_3d0bff8d98fd2bf7f193c258d80d2e9fab5bacd9';
  private consumerSecret = 'cs_b29c6615187b7abf4efcb6bc5b76653fdbd5c1e0';
  private apiUrl = 'https://mindfield-shop.com//wp-json/wc/v3';
  private subscriptionsUrl = 'https://mindfield-shop.com/wp-json/wc/v3/subscriptions';
  private loginUrl = 'https://mindfield-shop.com/wp-json/jwt-auth/v1/token';

  constructor(
    private http: HttpClient
  )
  { }

  getHeaders(): HttpHeaders {
    const auth = btoa(`${this.consumerKey}:${this.consumerSecret}`);
    return new HttpHeaders({
      Authorization: `Basic ${auth}`
    });
  }
  login(username, password) {
    return this.http.post(this.loginUrl, { username, password });
  }
  logout() {
    localStorage.removeItem('shop_user');
  }
  saveUser(user) {
    localStorage.setItem('shop_user', user);
  }
  getUser() {
    return localStorage.getItem('shop_user');
  }
  getActiveSubscriptionByEmail(email) {
    const url = `${this.subscriptionsUrl}?search=${email}&status=active`;

    const headers = new HttpHeaders({
      Authorization: 'Basic ' + btoa(`${this.consumerKey}:${this.consumerSecret}`),
    });

    return this.http.get(url, { headers })
  }
  getUserIdByEmail(email: string): Observable<any> {
    return this.http.get<any[]>(`${this.apiUrl}/customers?email=${email}`, {
      headers: this.getHeaders()
    });
  }
  getSubscriptions(userId: number): Observable<any> {
    return this.http.get<any[]>(`${this.apiUrl}/subscriptions?customer=${userId}`, {
      headers: this.getHeaders()
    });
  }
  getSubscriptionProducts(language): Observable<any> {
    return this.http.get<any[]>(`${this.apiUrl}/products?type=subscription&lang=${language}`, {
      headers: this.getHeaders()
    });
  }
  isTokenExpired(decodedToken): boolean {
    if (!decodedToken) return true;
    return decodedToken.exp * 1000 < Date.now();
  }
  getShopEarnings(period: string = 'last_month'): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/reports/sales?period=${period}`, {
      headers: this.getHeaders()
    });
  }
  checkIfDeviceSubscriptionNeeded(subscriber: IUser): any {
    return new Observable((observer) => {
      this.devicesList.subscribe((devices) => {
        const userDevice = devices.find(device => device.users.some(user => user.id === subscriber.id));
        this.userDevice = userDevice;
        observer.next(!!(userDevice && userDevice.subscriptionNeeded));
      });
    });
  }
  isSubscriptionsHaveError(subscriber: IUser) {
      this.checkIfDeviceSubscriptionNeeded(subscriber).subscribe((subscriptionNeeded) => {
        if (!subscriptionNeeded) {
          this.subscriptionsError.next(false);
          return;
        }
        const user = JSON.parse(this.getUser());
        if (!user) {
          this.subscriptionsError.next(true);
        } else {
          const token = user.token;
          const decoded = jwtDecode(token);
          const tokenExpired = this.isTokenExpired(decoded);
          if (tokenExpired) {
            this.subscriptionsError.next(true);
          }
          this.getActiveSubscriptionByEmail(user.user_email).subscribe((subscriptions:any[]) => {
            const sub1 = {
              id: 42416,
              name: '111'
            }
            // subscriptions.push(sub1)
            if (!subscriptions || !subscriptions.length) {
              this.subscriptionsError.next(true);
            } else {
              this.subscriptionsError.next(false);
              // const monthSubscription = this.userDevice.subscriptionType === 'month';
              // if (monthSubscription) {
              //   const haveMonthSubscription = subscriptions.some(sub => SENSOR_MONTH_SUBSCRIPTIONS.includes(sub.id));
              //   this.subscriptionsError.next(!haveMonthSubscription);
              // } else {
              //   const haveYearSubscription = subscriptions.some(sub => SENSOR_YEAR_SUBSCRIPTIONS.includes(sub.id));
              //   this.subscriptionsError.next(!haveYearSubscription);
              // }
            }
          });
        }
      });
  }
}
